exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dollar[data-v-5b4617c8] {\n  width: 100%;\n  height: auto;\n  user-select: none;\n  font-size: 16px;\n  font-size: 13.5vw;\n  font-weight: bold;\n  color: rgba(255, 255, 255, 0.1);\n}\n.dollar > p[data-v-5b4617c8] {\n    display: block;\n    line-height: 0px;\n    position: absolute;\n    top: -24%;\n}\n.md-card-actions[data-v-5b4617c8] {\n  position: relative;\n  top: 80px;\n  left: -15px;\n}\n.md-field[data-v-5b4617c8]:last-child {\n  margin-bottom: 40px;\n}\n", ""]);

// exports
